import { getData, postData, putData } from "./axiosConfig"

export const payout = async (body) => {
    return await postData('/wallet/payout-request', body)
}
export const createAccount = async (body) => {
    return await postData('/account-create', body)
}

export const transactionHistory = async (startDate, endDate) => {
    if (startDate && endDate) {
        return await getData(`/wallet/transactions?start_date=${startDate}&end_date=${endDate}`)
    } else {
        return await getData('/wallet/transactions')
    }


}
export const withdrawalHistory = async (startDate, endDate) => {
    if (startDate && endDate) {
        return await getData(`/wallet/transactions-history?start_date=${startDate}&end_date=${endDate}`)
    } else {
        return await getData('/wallet/transactions-history')
    }
}

export const me = async (id) => {
    return await getData(`/me/${id}`)
}

export const updateProfile = async (body) => {
    return await putData('/profile-update', body)
}

export const removeNotice = async (notice_id, body) => {
    return await putData(`/notice-cancel/${notice_id}`, body)
}

export const updatePassword = async (body) => {
    return await putData("/password-update", body)
}

export const withdrawableTransactions = async () => {
    return await getData('/wallet/withdrawable-transactions')
}

export const withdrawlRequest = async (body) => {
    return await postData('/wallet/withdrawl-request', body)
}


export const bankListRequest = async () => {
    return await getData('/admin/bank-list',)
}